function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}function _createClass(Constructor, protoProps, staticProps) {if (protoProps) _defineProperties(Constructor.prototype, protoProps);if (staticProps) _defineProperties(Constructor, staticProps);return Constructor;}import styles from "./recipe-meal.scss";
import template from "./recipe-meal.html";

export var RecipeMealComponent = {
  template: template,
  styles: styles,
  bindings: {
    viewTitle: "@",
    viewName: "@",
    difficult: "@",
    cookTime: "@",
    thumbnail: "@",
    details: "@",
    recipeItem: '<',
    _onChoose: '&onChoose',
    _onWeekChoose: '&onWeekChoose',
    _onFavoriteClick: '&onFavoriteClick',
    favorite: "=" },

  controller: /*#__PURE__*/function () {
    function RecipeMealComponentController() {
      "ngInject";_classCallCheck(this, RecipeMealComponentController);
    }_createClass(RecipeMealComponentController, [{ key: "onChoose", value: function onChoose(

      e) {
        e.preventDefault();
        e.stopPropagation();
        this._onChoose();
      } }, { key: "onWeekChoose", value: function onWeekChoose(

      e) {
        e.preventDefault();
        e.stopPropagation();
        this._onWeekChoose();
      } }, { key: "favoriteIconClick", value: function favoriteIconClick(

      e) {
        e.stopPropagation();
        this._onFavoriteClick();
      } }]);return RecipeMealComponentController;}() };